import React, { useState, useRef, useEffect } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Mnavigation';
import Footer from './gapsy-footer';

import { useLocation, useNavigate } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import axios from 'axios';
import { Modal, Form, Button, Dropdown } from 'react-bootstrap';
import { TableHeader, toCamelCaseforTableProps } from "../components/TableProperty"
import { PortURL, checksumAPI, Checker_list, Template_list_columns, checkerassignedtemplates, Uploadtemplate, dropdownlist, userWisedept, ColumnOrder } from '../components/ApiProperty';
import { UploadLoadingIcon, ListPopSize } from "../components/Propertyfile";
import { FaPlus } from "react-icons/fa";
import { upload3001, uploadMutiple, Bulkuploaddata, assigntemplate } from '../components/ApiProperty';
import { jsPDF } from "jspdf";




const TemplateUpload = () => {
  const [selectedFormat, setSelectedFormat] = useState("");
  const [fileInputKey, setFileInputKey] = useState(0);
  const [validCSVData, setValidCSVData] = useState(null);
  const [validFormattedRecords, setValidFormattedRecords] = useState([]);
  const [csvDataBackup, setCsvDataBackup] = useState(null);
  const [validRecords2, setValidRecords2] = useState([]);
  const [uploadedRecordCount, setUploadedRecordCount] = useState(0);
  const [validRecords1, setvalidRecords1] = useState("");
  const [originalTableName, setOriginalTableName] = useState('');
  const [uploadName, setUploadName] = useState(localStorage.getItem('uploadedFileName') || '');
  const [isValidationPassed, setIsValidationPassed] = useState(false);
  const [columnDropdown, setcolumnDropdown] = useState({});
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [columnDetails, setColumnDetails] = useState({});
  const [errorMessages, setErrorMessages] = useState([]);
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [messageType1, setMessageType1] = useState(''); // 'success' or 'error'
  const [modalMessage2, setModalMessage2] = useState('');

  const [parsedRows, setParsedRows] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [editableTableName, setEditableTableName] = useState('');

  const [isTableVisible, setIsTableVisible] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [isTableNameVisible, setIsTableNameVisible] = useState(true);
  const [isUploadComplete, setIsUploadComplete] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [userPage, setUserPage] = useState(1);
  const [users, setUsers] = useState([]);
  const [selectedCheckerName, setSelectedCheckerName] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [templateAssignments, setTemplateAssignments] = useState({});
  const [unsavedChanges, setUnsavedChanges] = useState(false); // Track unsaved changes
  const [showPreview, setShowPreview] = useState(false);

  const [headers, setHeaders] = useState([]);
  const [showUploadButton, setShowUploadButton] = useState(false);
  const [previewData, setPreviewData] = useState([]); // State for preview data
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedDownloadFormat, setSelectedDownloadFormat] = useState('');
  const [uploadPromptVisible, setUploadPromptVisible] = useState(false);
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const filePromptShownRef = useRef(false);
  const [showSheetSelection, setShowSheetSelection] = useState(true);
  const [mainSheet, setMainSheet] = useState(null);
  const [selectedSheets, setSelectedSheets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);

  const location = useLocation();
  const { tableHtml } = location.state || {};
  const [invalidDeptMessage, setInvalidDeptMessage] = useState('');
  const [tableName, setTableName] = useState('');
  const [uploadsName, setUploadsName] = useState("");
  const [isDownloaded, setIsDownloaded] = useState(false);
  // State for error message and styling
  const [invalidTableNameMessage, setInvalidTableNameMessage] = useState('');
  const [invalidTableNameMessage1, setInvalidTableNameMessage1] = useState('');
  const [validErrorRecords, setvalidErrorRecords] = useState("");
  const [messageType2, setMessageType2] = useState(''); // 'success' or 'error'
  const [modalMessage1, setModalMessage1] = useState('');
  // State for managing popups
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showNotifyModal, setShowNotifyModal] = useState(false); // State to control modal visibility
  const [notifyOption, setNotifyOption] = useState('EOD'); // State for radio button selection
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'
  const [modalMessage, setModalMessage] = useState('');
  const [modalMessage3, setModalMessage3] = useState('');

  const allowedTypes = ['int', 'varchar', 'date', 'double', 'boolean', 'decimal', 'float', 'char']; // Define allowed types
  const [showNoRecordsModal, setShowNoRecordsModal] = useState(false);
  const [recordsPerPage, setRecordsPerPage] = useState(200);
  const [searchTerm, setSearchTerm] = useState('');
  const [isUploadAllowed, setIsUploadAllowed] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTableName, setSelectedTableName] = useState(null);
  const [fileSelectionMessage, setFileSelectionMessage] = useState('');
  const [showFileSelectionModal, setShowFileSelectionModal] = useState(false);
  const [previewLimit, setPreviewLimit] = useState(100);
  const [originalTableData, setOriginalTableData] = useState([]);
  const [activeEditCell, setActiveEditCell] = useState({ rowIndex: null, columnName: null });
  const [selectedNumericColumns, setSelectedNumericColumns] = useState([]);
  const [renameDone, setRenameDone] = useState(false);
  const [showAllowUploadPopup, setShowAllowUploadPopup] = useState(false);
  const [retryPayload, setRetryPayload] = useState(null);
  const activeStatus = localStorage.getItem("active_status");
  const templateType = localStorage.getItem("template_type");
  const stage = localStorage.getItem("stage");
  const [departments, setDepartments] = useState("");
  const [selectedDept, setSelectedDept] = useState('');
  localStorage.setItem('selectedDept', selectedDept);

  let csrfToken = sessionStorage.getItem("tokenizedSession");


  const department = sessionStorage.getItem("dept");

  const navigate = useNavigate();

  const fileInputRef = useRef(null);

  const [selectedFile, setSelectedFile] = useState(null);

  const designTemplate = JSON.parse(localStorage.getItem('designtemplate')) || [];
  let dataModelLocal;
  let tableDatalocal;
  let tableNamelocal;

  // If a valid latestMessage exists, parse and extract data
  if (designTemplate) {

    try {

      const textData = designTemplate;
      dataModelLocal = textData.data_model || '';
      tableDatalocal = textData.table_data || {};
      tableNamelocal = textData.table_name || '';

    } catch (error) {
      console.error('Error parsing latestMessage text:', error);
    }
  }
  useEffect(() => {
    if (tableNamelocal) {
      // Set table name for input field (without .csv)
      const cleanName = tableNamelocal.replace('.csv', '');
      setEditableTableName(cleanName);

      // Set the original uploaded filename (with .csv)
      setUploadsName(tableNamelocal.endsWith('.csv') ? tableNamelocal : `${tableNamelocal}.csv`);
    }
  }, [tableNamelocal]);


  // Define the static response object with the extracted data
  const staticResponse = {
    data_model: dataModelLocal,
    table_data: {
      column_names: tableDatalocal.column_names || [],  // Ensure column_names is defined
    },
    table_name: tableNamelocal,
  };

  useEffect(() => {
    setRenameDone(false);
  }, [editableTableName]);


  useEffect(() => {
    const fetchColumns = async () => {
      setLoading(true);
      try {
        const config = {
          params: { adminId: localStorage.getItem("userid") },
          headers: {
            'x-csrf-token': csrfToken,
          },
          withCredentials: true,
        };

        const response = await axios.post(Template_list_columns, {}, config);

        if (response.data.status === "success") {
          const apiColumns = response.data.columns;
          const { column_names } = staticResponse.table_data;

          // Define the desired order of columns
          const desiredOrder = [
            "col_name",
            "col_type",
            "col_length",
            "col_label",
            "col_key",
            "col_rename",
            "col_active",
            "col_functions",
          ];

          // Define a mapping for column name transformations
          const columnNameMapping = {

          };

          // Static column to include
          const defaultReportingRow = {
            col_name: "Reporting_Date",
            col_type: "DATE",
            col_length: "", // Specify if applicable
            col_label: "REPORTING DATE",
            col_key: "PRIMARY KEY",
            col_rename: "",
            col_active: "",
            col_functions: "",
          };

          // Process the static column names with the mapping
          const mappedColumnNames = column_names.map((colName) =>
            columnNameMapping[colName] || colName // Transform if in mapping, else keep original
          );

          // Match the transformed column names with the API response
          const processedData = mappedColumnNames.map((mappedColName) => {
            const matchingColumn = apiColumns.find(
              (col) => col.col_name.toLowerCase() === mappedColName.toLowerCase()
            );

            if (matchingColumn) {
              // Include the entire matching column
              return matchingColumn;
            } else {
              // Include only col_name and leave other fields empty
              return desiredOrder.reduce((acc, field) => {
                acc[field] = field === "col_name" ? mappedColName : "";
                return acc;
              }, {});
            }
          });

          // Overwrite or ensure `Reporting_Date` uses default values
          const updatedData = processedData.map((row) =>
            row.col_name === "Reporting_Date" ? defaultReportingRow : row
          );

          // Ensure `Reporting_Date` is included and placed first
          const isReportingDateIncluded = updatedData.some(
            (row) => row.col_name?.toLowerCase() === "reporting_date"
          );
          if (!isReportingDateIncluded) {
            updatedData.unshift(defaultReportingRow);
          }

          // Set headers and table data
          setHeaders(desiredOrder);
          setTableData(updatedData);
          setOriginalTableData(updatedData);
        }
      } catch (error) {
        console.error("Error fetching API columns:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchColumns();
  }, []);


  const handleDepartmentChange = (e) => {
    setSelectedDept(e.target.value);
    setInvalidDeptMessage('');
  };


  const handleSelectChange = async (e) => {
    const selectedCheckerId = e.target.value;

    const selectedUser = users.find(user => user.id.toString() === selectedCheckerId);
    if (selectedUser) {
      setSelectedCheckerName(selectedUser.name);
    }


    const fetchAssignedTemplates = async (checkerId) => {
      setSelectedOption(checkerId);
      setTemplateAssignments({});
      setUnsavedChanges(false);
      setUserPage(1);
      if (checkerId) {
        try {
          const config = {
            params: {
              "adminId": localStorage.getItem('userid'),
              "userId": checkerId
            },
            headers: {
              'x-csrf-token': csrfToken,
            },
            withCredentials: true,
          };

          const response = await axios.post(checkerassignedtemplates, {}, config);

          if (response.data && Array.isArray(response.data.templates)) {
            const updatedTableData = response.data.templates.map((assignment) => {
              const checker = users.find(user => user.id === parseInt(checkerId));
              const tableNameParts = assignment.Table_name.split('_');
              const cleanedTableName = tableNameParts.slice(1).join('_');

              return {
                checkerId: checkerId,
                checkerName: checker?.name || '',
                selectedTemplate: cleanedTableName,
              };
            });

            setTableData(updatedTableData);
            setUserPage(1);
          } else {
            console.error('API response does not contain the expected structure');
          }
        } catch (error) {
          console.error('Error fetching template assignments:', error);
        }
      }
    };

    // No unsaved changes, proceed directly
    fetchAssignedTemplates(selectedCheckerId);
  };
  useEffect(() => {
    const fetchTemplatesCheckers = async () => {
      try {
        const config = {
          params: { "makerId": localStorage.getItem("userid"), "dept": selectedDept },
          headers: {
            'x-csrf-token': csrfToken,
          },
          withCredentials: true,
        };
        const responseChecker = await axios.post(Checker_list, {}, config);

        // Handle response - adjusted for the actual response structure
        if (responseChecker.data?.status === "success" && Array.isArray(responseChecker.data.checkers_list)) {
          setUsers(responseChecker.data.checkers_list.map(user => ({
            id: user.userId,
            name: user.userName
          })));
        } else {
          console.error('Unexpected checkers data structure:', responseChecker.data);
          setUsers([]);
        }

      } catch (error) {
        console.error('Error fetching users and templates:', error);
        setUsers([]);
        setTemplates([]);
      }
    };

    fetchTemplatesCheckers();
  }, [selectedDepartment]);


  const handleSuccessModalClose = () => {
    setShowModal2(false);
    setShowPreview(false);
    setShowModal1(false);
    setShowModal(false);
    setInvalidTableNameMessage1('');
  };


  const handleErrorModalClose = () => {
    setShowModal2(false);
    setShowPreview(false);
    setShowModal(false);
    setInvalidTableNameMessage1('');
  };




  const handleInputChange = (rowIndex, columnName, value) => {
    const updatedTableData = tableData.map((row, index) => {
      if (index === rowIndex) {
        const updatedRow = { ...row, [columnName]: value };

        if (columnName === 'col_type') {
          const colType = value ? value.toLowerCase() : "";

          if (['date', 'long'].includes(colType)) {
            updatedRow['col_length'] = "";
          } else if (['double', 'float', 'decimal'].includes(colType)) {
            updatedRow['col_length'] = "18,2"; // Default for decimal types
          } else if (colType === 'int') {
            updatedRow['col_length'] = "8";
          } else if (colType === 'varchar' || colType === 'char') {
            updatedRow['col_length'] = "32";
          } else if (colType === 'boolean') {
            updatedRow['col_length'] = "1";
          }
        }
        if (columnName === 'col_length' && row["col_type"]) {
          const colType = row["col_type"].toLowerCase();

          if (['double', 'float', 'decimal'].includes(colType)) {
            const isValid = /^\d+,\d+$/.test(value);
            if (!isValid && value !== "") {
              console.warn("Invalid col_length format. Expected comma-separated (e.g., 18,2)");
            }
          }
        }

        return updatedRow;
      }

      return row;
    });

    setTableData(updatedTableData);
  };

  const toTitleCase = (str) => {
    return str
      // Replace underscores or hyphens with spaces
      .replace(/[_-]/g, ' ')
      // Add space before capital letters (for camelCase)
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      // Capitalize first letter of each word
      .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
  };

  // Validation function for data type only
  const isValidDataType = (colType) => {
    return allowedTypes.includes(colType.toLowerCase());
  };

  const handleBlur = (rowIndex, colType, header, colName) => {
    if (header === 'col_type') {
      const updatedTableData = [...tableData];

      // Convert colType to lowercase for case-insensitive comparison
      const colTypeLower = colType ? colType.toLowerCase() : "";

      // Validate if col_type is allowed
      if (!isValidDataType(colTypeLower)) {
        updatedTableData[rowIndex][header] = ''; // Clear the invalid col_type
        updatedTableData[rowIndex]['col_length'] = ''; // Clear col_length if col_type is invalid

        setTableData(updatedTableData);
        setModalMessage(`Allowed datatypes: 'int', 'varchar', 'date', 'double', 'boolean', 'decimal'. Invalid data type: <strong>${toTitleCase(colType)}</strong>`);
        setShowModal(true);
      } else {
        // If col_type is 'date', disable and clear col_length
        if (['date', 'long'].includes(colTypeLower)) {
          updatedTableData[rowIndex]['col_length'] = ''; // Ensure col_length is empty
        }
        setTableData(updatedTableData);
      }
    }
  };

  const handleEditClick = () => {
    setIsEditMode(true);


  };
  const handleCancelUpload = () => {
    setShowAllowUploadPopup(false);
    setRetryPayload(null);
    setInvalidTableNameMessage1("Table already exists");
  };
  const handleCancel = () => {
    setShowModal(false);
    setShowDropdown(false);
    setShowSheetSelection(false);
    setInvalidTableNameMessage1('');

    setFileInputKey(prev => prev + 1);

    //  Always clear file-related state
    setSelectedFile(null);
    setSelectedFormat('');
    setSelectedDownloadFormat('');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }

    // Reset upload/preview state
    setPreviewData([]);
    setSelectedSheets([]);
    setMainSheet(null);
    setParsedRows([]);
    setModalMessage('');
    setIsUploadAllowed(false);
    setIsValidationPassed(false);
    setShowUploadButton(false);
    setUploadPromptVisible(false);
    filePromptShownRef.current = false;

    // Reset table/template state
    setTableData([]);
    setOriginalTableData([]);
    setIsUploadComplete(false);
    setSelectedDept('');
    setHeaders([]);
    setTableName('');
    setOriginalTableName('');
    setEditableTableName('');
    setUploadsName('');

    // Clear error records too
    setvalidErrorRecords([]);
    setShowAllowUploadPopup(false);
    setRetryPayload(null);
  };


  const handlePreviewOption = () => {
    if (loading1) return;

    // Ensure preview happens only if there are no errors and file is valid
    if (previewData.length > 0) {
      setShowPreview(true);
      setShowModal(true);
    } else {
      console.log("File has errors or no data available, showing NoDataModal");
    }
  };

  const handleAddRow = () => {
    setTableData([...tableData, headers.reduce((acc, header) => ({ ...acc, [header]: '' }), {})]);
  };


  const handleDeleteRow = () => {
    const newTableData = tableData.filter((_, index) => !selectedRows.includes(index));
    setTableData(newTableData);
    setSelectedRows([]);
    setShowDeletePopup(false); // Close the delete confirmation popup
  };

  const handleRowSelection = (rowIndex) => {
    const newSelectedRows = [...selectedRows];
    if (newSelectedRows.includes(rowIndex)) {
      newSelectedRows.splice(newSelectedRows.indexOf(rowIndex), 1);
    } else {
      newSelectedRows.push(rowIndex);
    }
    setSelectedRows(newSelectedRows);
  };

  const handleTableNameChange = (e) => {
    const value = e.target.value;
    setTableName(value);               // store backend value
    setEditableTableName(value);      // update UI

    const validPattern = /^[a-z0-9_]*$/;
    if (validPattern.test(value)) {
      setInvalidTableNameMessage('');
      setModalMessage('');
    } else {
      setInvalidTableNameMessage('Only lowercase letters, numbers, and underscores are allowed.');
      setModalMessage('Only lowercase letters, numbers, and underscores are allowed. Spaces or special characters are not allowed');
    }
  };




  const handleError = (message) => {
    // setErrorModalMessage(message);
    setShowErrorModal(true);
    setIsUploadAllowed(true); // Allow upload even if there's an error
  };


  const handleErrorClick = () => {
    // Handle the error without navigating the page
  };

  const handleModalClose = () => {
    setShowModal(false);
    setShowPreview(false);      //  Always reset this to avoid ghost preview
    setModalMessage('');
    setShowDropdown(false);
    setShowSheetSelection(false);


    if (messageType === 'success') {
      handleReset();          //  Reset state after successful upload
    } else {
      handleErrorClick();     //  Handle error path
    }

    setMessageType('');
  };


  const fetchFileAndColumnDetails = async () => {
    try {
      const config = {
        headers: {
          "userId": localStorage.getItem('userid'),
          'x-csrf-token': csrfToken,
        },
        withCredentials: true,
        params: { "tableName": `${selectedDept}_${editableTableName}` }
      };

      // Fetch column details
      const apiResponse = await axios.post(checksumAPI, {}, config);
      if (apiResponse.status !== 200) {
        setShowErrorModal(false);
        return;
      }

      const responseData = apiResponse.data;
      setColumnDetails(responseData);

      // Fetch dropdown file
      // const responsefromFile = await fetch(`${PortURL}/demformtemplate/${selectedDept}_${editableTableName}.json`);
      const responsefromFile = await fetch(`/demformtemplate/${selectedDept}_${editableTableName}.json`);
      if (!responsefromFile.ok) {
        console.error("Error fetching JSON file. Response:", responsefromFile);
        throw new Error("Nothing pending for Modification");
      }

      const responsetxt = await responsefromFile.json();

      if (!responsetxt || !responsetxt.details) {
        console.error("Error: JSON file does not contain 'details'");
      } else {
        setcolumnDropdown(responsetxt);
        console.log("columnDropdown is now set:", responsetxt);
      }

    } catch (error) {
      console.error("Error during file validation:", error);
      handleError(`Error validating file: ${error.message}`);
    }
  };


  const handleSubmit = async () => {

    if (!editableTableName) {
      setInvalidTableNameMessage('Please enter the table name.');
      return;
    }
    setInvalidTableNameMessage('');


    if (!selectedDept) {
      setInvalidDeptMessage('Please select a department.');
      return;
    } else {
      setInvalidDeptMessage('');
    }

    const result = FinalvalidateTableData();
    if (result) {
      setModalMessage(result.message);
      setMessageType(result.type); // "error" or "warning"
      setShowModal(true);
      if (result.type === "error") return; // block submission only on error
    }

    setIsUploadAllowed(true); // Allow upload if condition is met
    handleUpload1(true); // Explicitly proceed with upload
  };

  function detectValueFormat1(value) {
            if (!value || value.trim() === "") return "empty"; // Empty check first

            const lowerValue = value.toLowerCase();
            if (["true", "false"].includes(lowerValue)) return "boolean"; // Boolean check

            const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
            if (dateRegex.test(value)) return "date"; // Strict date format (YYYY-MM-DD)

            // Number checks
            if (!isNaN(value)) {
                if (/^[+-]?\d+$/.test(value)) return "int"; // Exact integer
                if (/^[+-]?\d*\.\d+$/.test(value)) return "decimal"; // Decimal (non-integer)
                if (/^[+-]?\d+(\.\d+)?[eE][+-]?\d+$/.test(value)) return "exponential"; // Exponential number
            }

            return "string"; // Default fallback
        }


        // const getColumnTypeFromDetails = async (columnName) => {
        function getColumnTypeFromDetails1(columnName) {
            // Loop through column types in columnDetails
            const columnTypes = [
                { type: "int", key: "int_columns" },
                { type: "decimal", key: "decimal_columns" },
                { type: "date", key: "date_columns" },
                { type: "double", key: "double_columns" },
                { type: "varchar", key: "varchar_columns" },
                { type: "number", key: "number_columns" },
                { type: "float", key: "float_columns" }
            ];

            for (const { type, key } of columnTypes) {
                if (columnDetails?.[key]?.some(col => col.col_name.includes(columnName))) {
                    return type;
                }
            }
            return "string"; // Default if not found
        }

  const downloadErrorsAsPDF = (errors = [], metadata = {}) => {
    const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

    const userId = localStorage.getItem('userid') || 'Unknown User';
    const createdDate = new Date().toLocaleString();

    // Title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('Data Validation Report', doc.internal.pageSize.getWidth() / 2, 20, { align: 'center' });

    // Metadata
    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');
    let metaY = 30;
    doc.text(`TableName: ${editableTableName}`, 14, metaY);
    doc.text(`Created By: ${userId}`, 14, metaY + 7);
    doc.text(`Created Date: ${createdDate}`, 14, metaY + 14);

    // Early return if no errors
    if (!Array.isArray(errors) || errors.length === 0) {
      doc.text('No validation errors found.', 14, metaY + 28);
      doc.save('validation_errors.pdf');
      return;
    }

    // Table body
    const tableBody = errors.map((error, index) => {
      const [primaryKey, rawMessage = ''] = error.split('|');
      const messages = rawMessage
        .split('#')
        .map(m => m.trim())
        .filter(Boolean)
        .join('\n');

      return [index + 1, primaryKey?.trim(), messages];
    });

    // Draw table
    doc.autoTable({
      startY: metaY + 25,
      head: [['S.No', 'Row Identifier', 'Message']],
      body: tableBody,
      styles: {
        fontSize: 11,
        valign: 'top',
        cellWidth: 'wrap',
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
      },
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 60 },
        2: { cellWidth: 160 },
      },
      headStyles: {
        fillColor: [0, 123, 255],
        textColor: 255,
        fontSize: 14,
        fontStyle: 'bold',
        halign: 'center',
        valign: 'middle',
      },
    });

    // doc.save('validation_errors.pdf');
    const safeFileName = editableTableName.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '');
    doc.save(`${userId}_${editableTableName}.pdf`);

  };

  const calculateColumnSum = (rows, columnNames, headers) => {
    const normalizeColumnName = (name) => name.replace(/\s+/g, "").toLowerCase();

    const columnSums = {};
    const columnCounts = {};

    // Normalize target column names
    const normalizedColumnNames = columnNames.map(normalizeColumnName);

    // Map normalized header -> index
    const normalizedHeaders = headers.reduce((acc, header, index) => {
      const norm = normalizeColumnName(header);
      acc[norm] = index;
      return acc;
    }, {});

    // Init
    normalizedColumnNames.forEach((col) => {
      columnSums[col] = 0;
      columnCounts[col] = 0;
    });

    rows.forEach((row) => {
      const regex = /(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g;
      const rowData = [...row.matchAll(regex)].map(match => match[1] ?? match[2] ?? "").map(cell => cell.trim());

      normalizedColumnNames.forEach((colName) => {
        const colIndex = normalizedHeaders[colName];
        if (colIndex !== undefined) {
          let value = rowData[colIndex] || "0";
          // value = value.replace(/\(([^)]+)\)/, "-$1").replace(/,/g, "");
          value = value.replace(/-\s+/g, '-').replace(/\(([^)]+)\)/, "-$1").replace(/,/g, "");
          const numericValue = parseFloat(value);
          if (!isNaN(numericValue)) {
            columnSums[colName] += numericValue;
            columnCounts[colName] += 1;
          }
        }
      });
    });

    return { columnSums, columnCounts };
  };


  const handlePreview = () => {
    const normalizeColumnName = (name) => name.replace(/\s+/g, "").toLowerCase(); // Normalize column names

    // Normalize database column names and create a mapping
    const dbColumnNames = [
      ...(columnDetails.int_columns?.[0]?.col_name || []),
      ...(columnDetails.double_columns?.[0]?.col_name || []),
      ...(columnDetails.decimal_columns?.[0]?.col_name || []),
      ...(columnDetails.float_columns?.[0]?.col_name || [])
    ];

    const normalizedDbColumns = dbColumnNames.reduce((acc, col) => {
      acc[normalizeColumnName(col)] = col; // Store mapping of normalized -> original
      return acc;
    }, {});

    // Normalize headers and map to the correct DB column
    const headers = previewData[0]
      ?.split(',')
      .map((header) => normalizeColumnName(header)) || [];

    // Convert uploaded column names to match DB names if possible
    const matchedHeaders = headers.map((header) => normalizedDbColumns[header] || header);

    const dataRows = previewData.slice(1, previewLimit + 1); // Exclude header row
    return calculateColumnSum(dataRows, Object.keys(normalizedDbColumns), matchedHeaders);
    // return calculateColumnSum(dataRows, Object.keys(normalizedDbColumns), Object.values(normalizedDbColumns));

  };

  const { columnSums, columnCounts } = handlePreview();
  const handleUpload1 = async (allowUpload) => {
    // Determine if upload is allowed: use the explicit parameter if provided, otherwise fall back to state
    const uploadAllowed = allowUpload !== undefined ? allowUpload : isUploadAllowed;

    if (!uploadAllowed) {
      setFileSelectionMessage('File validation failed. Please correct the errors and try again.');
      setShowFileSelectionModal(true);
      return;
    }

    try {
      await proceedWithUpload();
    } catch (error) {
      console.error('Error during upload:', error);
      setFileSelectionMessage('An error occurred during the upload. Please try again.');
      setShowFileSelectionModal(true);
    }
  };

  const proceedWithUpload = async () => {
    setLoading(true);

    const txtContent = tableData.map(row =>
      headers.map(header => {
        const value = row[header];
        if (
          ['date', 'long'].includes((row['col_type'] || '').toLowerCase()) &&
          (value === null || value === 'null' || value === 'NULL')
        ) {
          return '';
        }
        return value == null ? '' : value;
      }).join("|")
    ).join("\n");

    const blob = new Blob([txtContent], { type: 'text/plain' });
    const txtFile = new File([blob], `${editableTableName}.txt`, { type: 'text/plain' });
    const formData = new FormData();
    formData.append('file', txtFile);
    formData.append('tableName', editableTableName);
    formData.append('notifyOption', notifyOption);

    try {
      const uploadResponse = await axios.post(upload3001, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'userId': localStorage.getItem('userid'),
          'x-csrf-token': csrfToken,
        },
        withCredentials: true,
      });

      if (uploadResponse.status === 200) {
        const fileName = txtFile.name.replace('.txt', '');
        const filePath = "/saswork/nas/";
        await callAdditionalApi(fileName, filePath, notifyOption);
      }
    } catch (error) {
      console.error('File upload failed:', error.message);
      setIsUploadAllowed(false);
      setInvalidTableNameMessage('File upload failed. Please try again.');
      setModalMessage(true);
    } finally {
      setLoading(false);
    }
  };


  const handleCloseModal = () => {
    setShowModal(false);
    setShowPreview(false);
  }

  const validateDropdownValues1 = async (csvData, columnDropdown) => {
    const totalRows = csvData.rows.length - 1; // Exclude header
    const batchSize = 25000; // Major batch splitting
    const totalBatches = Math.ceil(totalRows / batchSize);

    if (!columnDropdown?.details?.length) {
      console.warn("JSON file missing 'details', skipping validation.");
      return true;
    }

    const dropdownColumns = {};
    const columnLengths = {};
    const columnTypes = {};
    const columnKeys = {};

    const dateColumnIndices = [];
    const intColumnIndices = [];
    const decimalColumnIndices = [];
    const booleanColumnIndices = [];
    const doubleColumnIndices = [];
    const characterColumnIndices = [];
    const floatColumnIndices = [];

    columnDropdown.details.forEach((col, idx) => {
      const key = col.columnName.trim().toLowerCase();
      columnTypes[key] = col.columnType?.toLowerCase();
      columnKeys[key] = col.columnKey?.toLowerCase();

      if (typeof col.columnFunction === 'string') {
        const dropdownMatch = col.columnFunction.match(/dropdown:\[(.*?)\]/i);
        if (dropdownMatch) {
          dropdownColumns[key] = dropdownMatch[1].split(",").map(val => val.trim().toUpperCase()).filter(Boolean);
        }
      }

      if (col.columnLength) {
        if (typeof col.columnLength === 'string' && col.columnLength.includes(',')) {
          const [precision, scale] = col.columnLength.split(',').map(num => parseInt(num.trim(), 10));
          columnLengths[key] = { precision, scale };
        } else {
          columnLengths[key] = parseInt(col.columnLength, 10);
        }
      }

      switch (col.columnType?.toLowerCase()) {
        case "date": dateColumnIndices.push(idx); break;
        case "integer": intColumnIndices.push(idx); break;
        case "decimal": decimalColumnIndices.push(idx); break;
        case "float": floatColumnIndices.push(idx); break;
        case "boolean": booleanColumnIndices.push(idx); break;
        case "double": doubleColumnIndices.push(idx); break;
        case "character": characterColumnIndices.push(idx); break;
      }
    });

    const parsedRows = new Map();
    const processErrorsBatch1 = async (start, end) => {
      const batchErrors = [];
      const primaryKeyColumns = Object.keys(columnKeys).filter(k => columnKeys[k] === "primary key");

      const chunkSize = totalRows > 100000 ? 1000 : totalRows > 50000 ? 2000 : 5000;
      const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
      const exponentialRegex = /^[+-]?\d+(\.\d+)?[eE][+-]?\d+$/;

      const uniqueRows = new Map();
      const duplicateEntries = [];

      for (let i = start; i < end; i += chunkSize) {
        const chunkEnd = Math.min(i + chunkSize, end);

        for (let rowIndex = i; rowIndex < chunkEnd; rowIndex++) {
          const row = csvData.rows[rowIndex + 1];
          if (!parsedRows.has(rowIndex)) {
            const matches = [...row.matchAll(/(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g)].map(m => m[1] ?? m[2] ?? '');
            parsedRows.set(rowIndex, matches);
          }
          const matches = parsedRows.get(rowIndex);

          const lineNumber = rowIndex + 1;
          const errorMessages = [];

          const cleanedRow = row.trim();
          // const primaryKeyValues = primaryKeyColumns.map(pk => matches[csvData.headers.indexOf(pk)]).join(",");
          const primaryKeyValues = primaryKeyColumns.map((pk) => {
            const colIndex = csvData.headers.indexOf(pk);
            if (colIndex === -1) {
              return `${pk} (header missing)`;
            }

            const value = matches[colIndex]?.trim();
            if (!value) {
              return `Column ${colIndex + 1}`;
            }

            return value;
          }).join(", ");

          if (uniqueRows.has(cleanedRow)) {
            errorMessages.push(`Duplicate entry found for primary key: ${primaryKeyValues}.`);
          } else {
            uniqueRows.set(cleanedRow, primaryKeyValues);
          }

          csvData.headers.forEach((header, columnIndex) => {
            const columnName = header.trim().toLowerCase();
            let cellValue = matches[columnIndex]?.trim() || '';

            if (dropdownColumns[columnName] && !dropdownColumns[columnName].includes(cellValue.toUpperCase())) {
              errorMessages.push(`Column '${columnName}' has invalid dropdown value '${cellValue}'.`);
            }

            if (columnLengths[columnName]) {
              const maxLen = columnLengths[columnName];
              const formatted = cellValue.replace(/\(([^)]+)\)/g, "-$1");
              const actualLength = formatted.length;

              if (typeof maxLen === 'object') {
                const { precision, scale } = maxLen;
                const [intPart, decPart = ''] = formatted.replace(/[^\d.]/g, '').split('.');
                const totalDigits = intPart.length + decPart.length;
                if (totalDigits > precision || decPart.length > scale) {
                  errorMessages.push(`Column '${columnName}' exceeds precision/scale.`);
                }
              } else if (actualLength > maxLen) {
                errorMessages.push(`Column '${columnName}' exceeds length ${maxLen}.`);
              }
            }

            const detectedFormat = detectValueFormat1(cellValue).toLowerCase();
            let expectedType = getColumnTypeFromDetails1(columnName.toLowerCase());

            if (exponentialRegex.test(cellValue)) {
              let columnType = "unknown";
              if (columnDetails?.double_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                columnType = "double";
              } else if (columnDetails?.decimal_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                columnType = "decimal";
              } else if (columnDetails?.float_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                columnType = "float";
              } else if (columnDetails?.int_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                columnType = "int";
              } else if (columnDetails?.varchar_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                columnType = "varchar";
              } else if (columnDetails?.number_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                columnType = "number";
              } else if (columnDetails?.boolean_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                columnType = "boolean";
              } else if (columnDetails?.date_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                columnType = "date";
              }

              if (!["double", "decimal", "float"].includes(columnType)) {
                errorMessages.push(`Column '${columnName}' contains an Exponential value '${cellValue}' which is not allowed.`);
              }
            }

            if ((columnKeys[columnName] === 'primary key' || columnKeys[columnName] === 'not null') && !cellValue) {
              errorMessages.push(`Column '${columnName}' is required but missing.`);
            }
            if (cellValue !== "") {
              if (expectedType === "int") {
                if (detectValueFormat1(cellValue) !== "int") {
                  errorMessages.push(`Column '${columnName}' should be Integer but found: ${cellValue}`);
                }
              }

              else if (["decimal", "double", "float", "number"].includes(expectedType)) {
                // Proceed with number validation only if the value is not missing
                // const numericValue = Number(cellValue.replace(/,/g, ''));
                let sanitized = cellValue.replace(/-\s+/g, '-').replace(/,/g, '');

                if (/^\(\d+(\.\d+)?\)$/.test(sanitized)) {
                  sanitized = '-' + sanitized.replace(/[()]/g, '');
                }
                const numericValue = Number(sanitized);
                if (isNaN(numericValue) || cellValue.trim() === "") {
                  errorMessages.push(`Column '${columnName}' should be a valid number but found: ${cellValue}`);
                }
              }
              else if (expectedType === "date") {
                if (detectValueFormat1(cellValue) !== "date") {
                  errorMessages.push(`Column '${columnName}' should be in YYYY-MM-DD format but found: ${cellValue}`);
                }
              } else if (expectedType === "boolean") {
                if (detectValueFormat1(cellValue) !== "boolean") {
                  errorMessages.push(`Column '${columnName}' should be true or false but found: ${cellValue}`);
                }
              }
            }
          });

          if (errorMessages.length > 0) {
            batchErrors.push(`${primaryKeyValues}|Error at Line ${lineNumber}:# ${errorMessages.join(' # ')}`);
          }
        }
      }

      if (duplicateEntries.length > 0) {
        duplicateEntries.forEach(({ primaryKeyValues, lineNumber }) => {
          batchErrors.push(`${primaryKeyValues}|Error at Line ${lineNumber}: Duplicate entry found.`);

        });
      }

      return batchErrors;
    };




    const validationPromises = [];
    for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
      const start = batchIndex * batchSize;
      const end = Math.min((batchIndex + 1) * batchSize, totalRows);
      validationPromises.push(processErrorsBatch1(start, end)); // Run batches in parallel
    }


    let allErrors = [];
    // Collect errors as batches finish
    const results = await Promise.all(validationPromises);

    results.forEach(batchErrors => {
      if (batchErrors.length > 0) {
        allErrors.push(...batchErrors);
        setErrorMessages(prev => [...(prev || []), ...batchErrors]); // Progressive UI updates
      }
    });


    // const sortedErrors = allErrors.sort((a, b) => parseInt(a.split('|')[0]) - parseInt(b.split('|')[0]));
    const sortedErrors = allErrors.sort((a, b) => parseInt(a.split('|')[1]) - parseInt(b.split('|')[1]));


    if (sortedErrors.length > 0) {
      setErrorMessages(sortedErrors); // Final sorted version
      setIsUploadAllowed(true);
      setvalidErrorRecords(sortedErrors);
      // downloadErrorsAsPDF(sortedErrors)
      console.error("Validation Errors:", sortedErrors);
    } else {
      console.log('No validation errors found!');
    }

    const errorLineNumbers = new Set(
      sortedErrors.map(error => {
        // Extract line number from error message
        const parts = error.split('|');
        const linePart = parts[1]; // Error at Line 3: ...
        const match = linePart.match(/Line (\d+)/);
        return match ? parseInt(match[1], 10) : null;
      }).filter(num => num !== null)
    );

    const validRows = [];

    for (let rowIndex = 0; rowIndex < totalRows; rowIndex++) {
      const lineNumber = rowIndex + 1;
      if (!errorLineNumbers.has(lineNumber)) {
        validRows.push(csvData.rows[lineNumber]); // Note: rows[0] is usually header
      }
    }

    const formattedValidRecords = validRows
      .map(row => {
        const regex = /(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g;
        const matches = [...row.matchAll(regex)].map(m => m[1] ?? m[2] ?? '');

        return matches.map((value, index) => {
          value = value.trim();

          const columnName = csvData.headers[index]?.trim().toLowerCase();
          const colType = columnTypes[columnName];
          const colKey = columnKeys[columnName];

          // if (dateColumnIndices.includes(index)) {
          //     return value;
          // }

          if (dateColumnIndices.includes(index) && value) {
            return value;   // valid date → return as-is
          }


          if (value.startsWith('(') && value.endsWith(')')) {
            value = `-${value.slice(1, -1)}`;
          }

          value = value.replace(/,/g, '');

          // 🔹 Insert '/N' for empty Decimal/Double/Float columns when columnKey is null
          if (
            !value &&
            (!colKey || colKey === 'null' || colKey === null) &&
            ['decimal', 'double', 'float', 'date'].includes(colType)
          ) {
            value = '\\N';
          }

          return value;
        }).join('|');
      })
      .join('\n');

    setvalidRecords1(formattedValidRecords);
    // return true;
    return {
      formattedValidRecords,
      sortedErrors,
    };

  };

  // const recordsCount = previewData.length > 1 ? previewData.length - 1 : 0;

  const continueAfterValidation = async (csvData, formattedValidRecords) => {
    setLoading1(true);
    setIsValidationPassed(true);
    setShowPreview(false);
    // Ensure validRecords is always treated as an array of lines
    const validRecordsArray = Array.isArray(formattedValidRecords)
      ? formattedValidRecords
      : typeof formattedValidRecords === "string"
        ? formattedValidRecords.trim().split("\n").filter(line => line.trim() !== "")
        : [];

    if (!Array.isArray(validRecordsArray) || validRecordsArray.length === 0) {
      console.warn(" No valid records to upload. Skipping upload.");
      return;
    }
    const recordCount = validRecordsArray.length;
    setUploadedRecordCount(recordCount);

    const validRecordsBlob = new Blob(
      validRecordsArray.map(record => record + "\n"),
      { type: "text/plain" }
    );

    const formData = new FormData();
    formData.append('file', validRecordsBlob, `${editableTableName}.txt`);

    const uploadResponse = await axios.post(uploadMutiple, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', 'x-csrf-token': csrfToken, "userId": localStorage.getItem('userid')
      },
      withCredentials: true,
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setUploadProgress(percentCompleted);
      }
    });

    setCsvDataBackup(csvData);
    setValidRecords2(formattedValidRecords);
    setIsValidationPassed(true); // trigger button display

    const bulkuploadConfig = {
      headers: {
        "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
      },
      withCredentials: true,
      params: {
        tableName: editableTableName,
        recordsCount: recordCount,
        Notifications: "IN",
        filePath: `/saswork/nas/${editableTableName}.txt`,
        templateType: "BDM OCR Upload",
        keyValidation: "Y",
        colValidation: "N",
        dept: selectedDept,
        dataModel: "BDM",
        allowModify: " ",
        makerRemarks: "",
        allowUpload: "N",
      }
    };

    const bulkuploadResponse = await axios.post(Bulkuploaddata, {}, bulkuploadConfig);

    if (bulkuploadResponse.data.success) {
    }

    if (bulkuploadResponse.data?.active_status && bulkuploadResponse.data?.template_type && bulkuploadResponse.data?.stage) {
      localStorage.setItem("active_status1", bulkuploadResponse.data.active_status);
      localStorage.setItem("template_type1", bulkuploadResponse.data.template_type);
      localStorage.setItem("stage1", bulkuploadResponse.data.stage);
    }


    if (bulkuploadResponse.data && bulkuploadResponse.data.status === "success") {
      const tableTitle = toTitleCase(editableTableName);

      // Get message from backend and apply <strong> to table name
      const apiMessage = bulkuploadResponse.data.message || '';
      const updatedApiMessage = apiMessage.replace(
        new RegExp(`\\b${editableTableName}\\b`, 'gi'),
        `<strong>${tableTitle}</strong>`
      );

      const fullMessage = `<strong>${tableTitle}</strong> Template Created Successfully\n${updatedApiMessage}`;

      setModalMessage(fullMessage);
      setShowNotifyModal(false);
      setMessageType('success');
      setShowModal(true);
      setSelectedTableName(editableTableName);
      localStorage.setItem('selectedTableName', editableTableName);
    }
    else {

      // const message = `${recordsCount} record of <strong>${toTitleCase(selectedName)}</strong> Uploaded Failed`;
      const message = `<strong>${toTitleCase(editableTableName)}</strong> Template Created Successfully\nUpload Failed - ${recordCount} records of <strong>${toTitleCase(editableTableName)}`;
      // Show the message (log, alert, toast, etc.)

      setModalMessage(message);
      setMessageType('failure');
      // setrecordSuccess("N");
      setShowModal(true);

    }
    setLoading1(false);

  };


  const fetchCSVData = async (editableTableName, columnDropdown) => {
    try {
      // const filePath = `${PortURL}/uploads/${uploadsName}`;
      const filePath = `/uploads/${uploadsName}`;
      const response = await fetch(filePath);

      if (!response.ok) {
        throw new Error("Nothing Pending for Preview");
      }

      const csvText = await response.text();
      console.log("csvData after fetch", csvText);

      // const lines = csvText
      //     .split("\n")
      //     .map((line) => line.trim())
      //     .filter((line) => line !== "");

      const preprocessed = csvText.replace(/"([^"]*)"/gs, (match, group) => {
        // collapse CR/LF inside quoted fields into spaces
        return '"' + group.replace(/[\r\n]+/g, ' ') + '"';
      });

      const lines = preprocessed
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter((line) => line !== "");

      if (lines.length === 0) {
        throw new Error("CSV file is empty.");
      }

      const headerLine = lines[0];
      const dataRows = lines.slice(1);

      // Use actual CSV header, not columnDropdown
      const csvHeaders = headerLine
        .split(",")
        .map((cell) => cell.replace(/^"|"$/g, "").trim());

      const previewLines = [headerLine, ...dataRows];
      setPreviewData(previewLines);
      setIsUploadAllowed(true);

      const normalizedHeaders = csvHeaders.map(h =>
        h.trim().toLowerCase().replace(/\s+/g, "")
      );

      const csvData = { headers: normalizedHeaders, rows: lines };

      const extractCoreName = (fileName) => {
        const baseName = fileName.replace(/\.csv$/i, ""); // remove .csv
        const parts = baseName.split("_");
        return parts.slice(1).join("_"); // remove first prefix part
      };
      const cleanedName = extractCoreName(editableTableName);

      const { formattedValidRecords, sortedErrors } = await validateDropdownValues1(csvData, columnDropdown);

      setvalidErrorRecords(sortedErrors || []);


      if (sortedErrors?.length > 0 || !formattedValidRecords || formattedValidRecords.length === 0) {
        setModalMessage2(`<strong>${toTitleCase(cleanedName)}</strong> Template Created Successfully`);
        setMessageType2("success");
        setShowModal2(true);

        setModalMessage1("Data Upload failed, Please check the Data Validation Report\nCorrect data and re-upload through <strong>2.2 Bulkupload</strong>");
        setShowModal1(true);

        setIsValidationPassed(true);
        setIsUploadAllowed(false);
        setLoading(false);
        return;
      }
      setShowPreview(true);
      setShowModal(true);
      setIsValidationPassed(true);
      setValidCSVData(csvData);
      setValidFormattedRecords(formattedValidRecords);

    } catch (error) {
      console.error("Error fetching CSV data:", error.message);
      setIsValidationPassed(false);
    }
  };

  const compareColumnOrder = (expectedCols, actualCols) => {
    const mismatches = [];

    expectedCols.forEach((expectedCol, index) => {
      const actualCol = actualCols[index];
      if (expectedCol?.toLowerCase() !== actualCol?.toLowerCase()) {
        mismatches.push({
          expected: expectedCol,
          expectedPosition: index + 1,
          actual: actualCol || "Missing"
        });
      }
    });

    return mismatches;
  };

  const handleForceUpload = async () => {
    setShowAllowUploadPopup(false); // close the popup
    if (retryPayload) {
      const dropdownData = await fetchFileAndColumnDetails();
      if (!dropdownData) return;

      await fetchCSVData(`${selectedDept}_${retryPayload.editableTableName}.csv`, dropdownData);
    }
  };

  const callAdditionalApi = async (editableTableName, filePath, notifyType, dateColumnIndices, columnDropdown, sortedErrors = [], allowUpload = "N") => {
    setLoading(true);
    try {
      const uploadFileName = `${editableTableName}.csv`;
      // const filePathCsv = `/uploads/${uploadFileName}`;
      const filePathCsv = `/uploads/${selectedDept}_${uploadFileName}`;


      // Step 1: Call Uploadtemplate API
      const config = {
        headers: {
          userId: localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
        },
        withCredentials: true,
        params: {
          tableName: editableTableName,
          // dataModel: dataModelLocal,
          path: `${filePath}${editableTableName}.txt`,
          Notifications: "IN",
          templateType: "AI",
          "dept": selectedDept,
          allowUpload

        }
      };

      const response = await axios.post(Uploadtemplate, {}, config);

      if (response.data.status === 'failure') {
        if (response.data.message === 'Table already exists') {
          try {
            // const columnResponse = await axios.post(`${ColumnOrder}?tablename=${editableTableName}&dept=${selectedDept}`);
            const columnResponse = await axios.post(
              `${ColumnOrder}?tablename=${editableTableName}&dept=${selectedDept}`,
              {}, // empty request body
              {
                headers: {
                  'userId': localStorage.getItem('userid'),
                  'x-csrf-token': csrfToken
                }
              }
            );
            const expectedColumns = columnResponse.data.columns || [];

            const actualColOrder = tableData.map(row => (row.col_name || '').trim());
            const mismatches = compareColumnOrder(expectedColumns, actualColOrder);

            if (mismatches.length > 0) {
              const message = mismatches.map(m =>
                `<strong>${m.expected}</strong> column is expected at position <strong>${m.expectedPosition}</strong>${m.actual !== "Missing" ? `,` : ""}`
              ).join("<br/>");

              setModalMessage(`<strong>${toTitleCase(editableTableName)}</strong> Template: <br/>${message}`);
              setMessageType("error");
              setShowModal(true);
              setIsUploadAllowed(false);
              return;
            }

            // No mismatch — allow re-upload
            setRetryPayload({ editableTableName }); // store only what's needed
            setModalMessage3(`<strong>${toTitleCase(editableTableName)}</strong> Template already exists.<br /> Do you wish to upload data with existing template?`);
            setShowAllowUploadPopup(true);          // show Yes/No popup
            return;
          } catch (err) {
            console.error("Failed to compare column order:", err.message);
            setModalMessage("Could not verify column order. Please try again.");
            setMessageType("failure");
            setShowModal(true);
            setIsUploadAllowed(false);
            return;
          }
        }
        setModalMessage(response.data.message);
        setShowModal(true);
        setMessageType('failure');
        setIsUploadAllowed(false);
        setLoading(false);
        return;
      }
      else if (response.data?.message === 'Template Created Successfully') {

        const mappedid = localStorage.getItem('userid');
        const adminId = localStorage.getItem('userid');

        const assignPayload = {
          adminId,
          detail: [
            {
              mappedid,
              template: editableTableName
            }
          ]
        };

        const assignConfig = {
          params: { type: "regular", Notifications: "IN", dept: selectedDept },
          headers: {
            'x-csrf-token': csrfToken,
          },
          withCredentials: true
        };

        // Step 1: Make the API call to assign template
        const assignResponse = await axios.post(assigntemplate, assignPayload, assignConfig);

        // Step 2: Handle the response and store data in localStorage
        if (assignResponse?.data?.active_status && assignResponse.data.template_type && assignResponse.data.stage) {
          localStorage.setItem("active_status", assignResponse.data.active_status);
          localStorage.setItem("template_type", assignResponse.data.template_type);
          localStorage.setItem("stage", assignResponse.data.stage);

          const dropdownData = await fetchFileAndColumnDetails();
          if (!dropdownData) return;

          await fetchCSVData(`${selectedDept}_${editableTableName}.csv`, dropdownData);

        }
      }
    } catch (error) {
      console.error('Error in callAdditionalApi:', error.response?.data || error.message);
      setIsUploadAllowed(false);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (columnName) => {
    const normalized = columnName.replace(/\s+/g, "").toLowerCase();
    setSelectedNumericColumns(prevSelected => {
      const updated = prevSelected.includes(normalized)
        ? prevSelected.filter(col => col !== normalized)
        : [...prevSelected, normalized];
      return updated;
    });
  };

  const validateTableData = () => {
    const allowedTypes = ["int", "varchar", "date", "double", "boolean", "decimal", "float", "char"];

    const invalidColTypeRow = tableData.find((row) =>
      row.col_type && !allowedTypes.includes(row.col_type.toLowerCase())
    );

    if (invalidColTypeRow) {
      return { type: "error", message: `Allowed datatypes: 'int', 'varchar', 'date', 'double','boolean', 'decimal', 'float'. Invalid data type: <strong>${toTitleCase(invalidColTypeRow.col_type)}</strong>` };
    }

    const invalidRow = tableData.find((row) => !row.col_name || !row.col_type);

    const invalidColLengthRow = tableData.find((row) =>
      row.col_type &&
      ["varchar", "int"].includes(row.col_type.toLowerCase()) &&
      (!row.col_length || row.col_length === '' || isNaN(row.col_length))
    );

    const rename = tableData.find((row) =>
      row.col_rename &&
      row.col_name &&
      row.col_rename.trim().toLowerCase() === row.col_name.trim().toLowerCase()
    );

    const duplicateColumn = tableData.reduce((acc, row) => {
      const name = row.col_name?.trim().toLowerCase();
      if (name) {
        acc[name] = (acc[name] || 0) + 1;
      }
      return acc;
    }, {});

    const duplicate = Object.entries(duplicateColumn).find(([_, count]) => count > 1);

    const commaSeparatedNumberRegex = /^\d+(\.\d+)?(,\d+(\.\d+)?)*$/;

    const invalidCommaSeparatedRow = tableData.find((row) =>
      row.col_type &&
      ["double", "decimal", "float"].includes(row.col_type.toLowerCase()) &&
      row.col_value &&
      !commaSeparatedNumberRegex.test(row.col_value.trim())
    );

    const invalidDoubleColLengthRow = tableData.find((row) =>
      row.col_type &&
      ["double", "float", "decimal"].includes(row.col_type.toLowerCase()) &&
      (!row.col_length || row.col_length.trim() === "" || !/^\d+(\.\d+)?(,\d+(\.\d+)?)+$/.test(row.col_length.trim()))
    );

    const invalidColNameRow = tableData.find((row) => {
      const colName = String(row.col_name || "");
      const isValid = /^[A-Za-z0-9_]+$/.test(colName);
      return !isValid;
    });

    const invalidReportingDateRow = tableData.find((row) => {
      const colName = String(row.col_name || "").trim().toLowerCase();
      const colKey = String(row.col_key || "").trim().toLowerCase();
      return colName === "reporting_date" && colKey !== "primary key";
    });

    const primaryKeys = tableData.filter(
      (row) => String(row.col_key || "").toLowerCase() === "primary key"
    );

    const hasOnlyReportingDateAsPK =
      primaryKeys.length === 1 &&
      String(primaryKeys[0].col_name || "").trim().toLowerCase() === "reporting_date";

    const reportingDateAsPrimaryKey = tableData.find(
      (row) =>
        String(row.col_name || "").trim().toLowerCase() === "reporting_date" &&
        String(row.col_key || "").trim().toLowerCase() === "primary key"
    );

    const floatTypes = ['double', 'decimal', 'float'];
    const floatTypesFormatted = floatTypes.map(toTitleCase).join(', ').replace(/, ([^,]*)$/, ' and $1');


    if (duplicate) {
      return { type: "error", message: `COLUMN_NAME <strong>${toTitleCase(duplicate[0])}</strong> is already available. Please choose a different name.` };
    } else if (invalidRow) {
      return { type: "error", message: "Required field(s) must not be <strong>Blank</strong>" };
    } else if (invalidColLengthRow) {
      return { type: "error", message: "COLUMN_LENGTH is required, and must be a valid Number for the selected COLUMN_TYPE" };
    } else if (rename) {
      return { type: "error", message: "<strong>COLUMN_RENAME/strong> field cannot have the same name as <strong>COLUMN_NAME</strong>. Please provide a different name." };
    } else if (invalidCommaSeparatedRow) {
      return { type: "error", message: `COLUMN_LENGTH must be in precision,scale (eg: 18,2) for COLUMN_TYPE Double, Float and Decimal` };
    } else if (invalidDoubleColLengthRow) {
      return { type: "error", message: `COLUMN_LENGTH must not be <strong>Blank</strong> for COLUMN_TYPE Double, Float and Decimal` };
    } else if (invalidColNameRow) {
      return { type: "error", message: `Invalid (or) Incorrect COLUMN_NAME <strong>${toTitleCase(invalidColNameRow.col_name)}</strong>. Letters (A-Z, a-z), Numbers (0-9), and Underscores (_) are only allowed` };
    } else if (invalidReportingDateRow) {
      return { type: "error", message: `<strong>Reporting Date</strong> must be the Primary Key Column.` };
    } else if (primaryKeys.length === 0) {
      return { type: "error", message: "No </strong>Primary Key</strong> Column found in the Template." };
    } else if (hasOnlyReportingDateAsPK && primaryKeys.length === 1) {
      return { type: "error", message: "Include an additional Primary Key Column, other than <strong>Reporting Date</strong>." };
    } else if (!reportingDateAsPrimaryKey && primaryKeys.length > 0) {
      return { type: "warning", message: "COLUMN_NAME <strong>Reporting Date</strong> is missing. Include if it's Required." };
    }

    return null;
  };


  const FinalvalidateTableData = () => {
    const allowedTypes = ["int", "varchar", "date", "double", "boolean", "decimal", "float", "char"];

    const invalidColTypeRow = tableData.find((row) =>
      row.col_type && !allowedTypes.includes(row.col_type.toLowerCase())
    );

    if (invalidColTypeRow) {
      return { type: "error", message: `Allowed datatypes: 'int', 'varchar', 'date', 'double','boolean', 'decimal', 'float'. Invalid data type: <strong>${toTitleCase(invalidColTypeRow.col_type)}</strong>` };
    }

    const invalidRow = tableData.find((row) => !row.col_name || !row.col_type);

    const invalidColLengthRow = tableData.find((row) =>
      row.col_type &&
      ["varchar", "int"].includes(row.col_type.toLowerCase()) &&
      (!row.col_length || row.col_length === '' || isNaN(row.col_length))
    );

    const rename = tableData.find((row) =>
      row.col_rename &&
      row.col_name &&
      row.col_rename.trim().toLowerCase() === row.col_name.trim().toLowerCase()
    );

    const duplicateColumn = tableData.reduce((acc, row) => {
      const name = row.col_name?.trim().toLowerCase();
      if (name) {
        acc[name] = (acc[name] || 0) + 1;
      }
      return acc;
    }, {});

    const duplicate = Object.entries(duplicateColumn).find(([_, count]) => count > 1);

    const commaSeparatedNumberRegex = /^\d+(\.\d+)?(,\d+(\.\d+)?)*$/;

    const invalidCommaSeparatedRow = tableData.find((row) =>
      row.col_type &&
      ["double", "decimal", "float"].includes(row.col_type.toLowerCase()) &&
      row.col_value &&
      !commaSeparatedNumberRegex.test(row.col_value.trim())
    );

    const invalidDoubleColLengthRow = tableData.find((row) =>
      row.col_type &&
      ["double", "float", "decimal"].includes(row.col_type.toLowerCase()) &&
      (!row.col_length || row.col_length.trim() === "" || !/^\d+(\.\d+)?(,\d+(\.\d+)?)+$/.test(row.col_length.trim()))
    );

    const invalidColNameRow = tableData.find((row) => {
      const colName = String(row.col_name || "");
      const isValid = /^[A-Za-z0-9_]+$/.test(colName);
      return !isValid;
    });

    const invalidReportingDateRow = tableData.find((row) => {
      const colName = String(row.col_name || "").trim().toLowerCase();
      const colKey = String(row.col_key || "").trim().toLowerCase();
      return colName === "reporting_date" && colKey !== "primary key";
    });

    const primaryKeys = tableData.filter(
      (row) => String(row.col_key || "").toLowerCase() === "primary key"
    );

    const hasOnlyReportingDateAsPK =
      primaryKeys.length === 1 &&
      String(primaryKeys[0].col_name || "").trim().toLowerCase() === "reporting_date";


    const floatTypes = ['double', 'decimal', 'float'];
    const floatTypesFormatted = floatTypes.map(toTitleCase).join(', ').replace(/, ([^,]*)$/, ' and $1');


    if (duplicate) {
      return { type: "error", message: `COLUMN_NAME <strong>${toTitleCase(duplicate[0])}</strong> is already available. Please choose a different name.` };
    } else if (invalidRow) {
      return { type: "error", message: "Required field(s) must not be <strong>Blank</strong>" };
    } else if (invalidColLengthRow) {
      return { type: "error", message: "COLUMN_LENGTH is required, and must be a valid Number for the selected COLUMN_TYPE" };
    } else if (rename) {
      return { type: "error", message: "<strong>COLUMN_RENAME/strong> field cannot have the same name as <strong>COLUMN_NAME</strong>. Please provide a different name." };
    } else if (invalidCommaSeparatedRow) {
      return { type: "error", message: `COLUMN_LENGTH must be in precision,scale (eg: 18,2) for COLUMN_TYPE Double, Float and Decimal` };
    } else if (invalidDoubleColLengthRow) {
      return { type: "error", message: `COLUMN_LENGTH must not be <strong>Blank</strong> for COLUMN_TYPE Double, Float and Decimal` };
    } else if (invalidColNameRow) {
      return { type: "error", message: `Invalid (or) Incorrect COLUMN_NAME <strong>${toTitleCase(invalidColNameRow.col_name)}</strong>. Letters (A-Z, a-z), Numbers (0-9), and Underscores (_) are only allowed` };
    } else if (invalidReportingDateRow) {
      return { type: "error", message: `<strong>Reporting Date</strong> must be the Primary Key Column.` };
    } else if (primaryKeys.length === 0) {
      return { type: "error", message: "No </strong>Primary Key</strong> Column found in the Template." };
    } else if (hasOnlyReportingDateAsPK && primaryKeys.length === 1) {
      return { type: "error", message: "Include an additional Primary Key Column, other than <strong>Reporting Date</strong>." };
    }

    return null;
  };

  const handleReset = () => {
    setSelectedTableName(null);
    setInvalidTableNameMessage('');
    setInvalidTableNameMessage1('');
    setIsTableVisible(true);
    setIsTableNameVisible(true);
    setSelectedRows([]);
    setShowDeletePopup(false);
    setSelectedDept('');
    setInvalidDeptMessage('');
    setIsEditMode(false);

    setTableName(originalTableName); //  Restore the original filename-based name
    setTableData(originalTableData); //  Restore original table content
  };

  const int_columns = columnDetails?.int_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
  const decimal_columns = columnDetails?.decimal_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
  const float_columns = columnDetails?.float_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
  const number_columns = columnDetails?.number_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];

  // const numeric_columns = columnDetails?.numeric_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
  const date_columns = columnDetails?.date_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
  const character_columns = columnDetails?.character_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
  // const char_columns = columnDetails?.char_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];

  const boolean_columns = columnDetails?.boolean_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
  const double_columns = columnDetails?.double_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];



  const handleUpdate = () => {
    const result = validateTableData();

    if (result) {
      setModalMessage(result.message);
      setMessageType(result.type);  // ← use the `type` from validateTableData directly
      setShowModal(true);

      if (result.type !== "warning") return; // Block submission only if it's an error
    }

    setIsEditMode(false);
    setSelectedRows([]);
  };

  const filteredTableData = tableData.filter(item =>
    Object.values(item).some(value =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalRecords = filteredTableData.length;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const currentRecords = filteredTableData.slice((currentPage - 1) * recordsPerPage, currentPage * recordsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  useEffect(() => {
    if (searchTerm && filteredTableData.length === 0) {
      setShowNoRecordsModal(true);
      setSearchTerm('');
      setCurrentPage(1);
    }
  }, [searchTerm, filteredTableData]);

  const updateSelectionAfterMove = (fromIndex, toIndex) => {
    const updatedSelected = [...selectedRows];
    if (updatedSelected.includes(fromIndex)) {
      updatedSelected.splice(updatedSelected.indexOf(fromIndex), 1, toIndex);
    }
    setSelectedRows(updatedSelected);
  };

  const fetchDropdownData = async () => {
    const adminId = localStorage.getItem('userid');

    const config = {
      headers: {
        "adminId": adminId,
        'x-csrf-token': csrfToken,
      },
      withCredentials: true
    };

    try {
      const response = await axios.post(dropdownlist, {}, config);
      const masterTableInfo = response.data?.master_table_info || []; // Safely extract master_table_info
      const colNames = masterTableInfo.map(item => item.col_name); // Extract col_name values
      setColNames(colNames); // Store in state
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };

  useEffect(() => {
    fetchDropdownData();
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [colNames, setColNames] = useState([]);
  const [selectedColName, setSelectedColName] = useState("");
  const [activeRowIndex, setActiveRowIndex] = useState(null);
  const [searchText, setSearchText] = useState(""); // To filter options

  // Function to handle dropdown button click for a specific row
  const handleDropdownClick = (rowIndex) => {
    setActiveRowIndex(rowIndex); // Set the active row index
    setIsModalOpen(true); // Open the modal
  };

  const handleOptionSelect = (selectedCol) => {

    const updatedData = tableData.map((row, index) => {
      if (index === activeRowIndex) {
        return {
          ...row,
          col_functions: selectedCol ? `dropdown(${selectedCol})` : "" // Clear if empty
        };
      }
      return row;
    });

    setTableData(updatedData); // Update the table data state
  };


  const handleOkClick = () => {
    if (selectedColName !== null) {
      handleOptionSelect(selectedColName); // This will pass empty string too
      setSearchText("");         // Reset search
      setSelectedColName("");    // Reset selection
      setIsModalOpen(false);     // Close modal
    }
  };

  const filteredColNames = colNames.filter((colName) =>
    colName.toLowerCase().includes(searchText.toLowerCase())
  ); // Filter based on search input


  useEffect(() => {
    const fetchUserDepartments = async () => {

      try {
        let config = {
          headers: {
            "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
          },
          withCredentials: true
        };
        // const response = await axios.post('http://172.16.119.156:8081/api/dept/userwise', {}, config);
        const response = await axios.post(userWisedept, {}, config);

        if (response.data?.department && Array.isArray(response.data.department)) {
          setDepartments(response.data.department.map((name, index) => ({
            id: index + 1,
            name
          })));
        } else {
          console.error('Unexpected department data structure:', response.data);
          setDepartments([]);
        }
      } catch (error) {
        console.error('Error fetching departments:', error);
        setDepartments([]);
      }

    };

    fetchUserDepartments();
  }, []);


  const handleDashboard = (e) => {
    e.preventDefault();
    navigate('/gapsyMdashboard');
    // Additional logic if needed
  };

  return (
    <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
      <Header />
      <Navigation />
      <div className="top-0 px-4 py-2 text-white">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-1">
                <li className="breadcrumb-item">
                  <a href="#" onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                    <i className="bi bi-house me-2"></i>/
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <a href="#" className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                    <i className="bi bi-arrow-repeat me-2"></i> Automated Data Load
                  </a>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <main className="flex-grow-1 container-fluid">
        <div className={styles.mainContainer}>
          <div className="container-fluid py-2">
            {/* <div className="row"> */}
            {/* Right Column with Buttons */}

            {/* Left Column with Table */}
            <div className="col-lg-12 col-md-12">
              <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                <div className="card-body">
                  <div className="mb-4">
                    <h6 className={`pb-1 mb-3 ${styles.borderBottom}`}>Template Preview</h6>
                    {/* Horizontal layout: Table and controls side by side */}
                    <div className="row">
                      {/* Table Column */}
                      <div className="col-md-9">
                        <div className="table-on-homepage-only">
                          {loading && (
                            <div className="loading-overlay">
                              <UploadLoadingIcon />
                            </div>
                          )}
                          {loading1 && (
                            <div className="loading-overlay">
                              <UploadLoadingIcon />
                            </div>
                          )}

                          {/* <div className="table-on-homepage-only"> */}
                          <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                            {isTableVisible && (
                              <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
                                <thead className="sticky-header">
                                  <tr>
                                    {isEditMode && <th style={{ textAlign: 'center', fontSize: '12px' }}></th>}
                                    {headers
                                      .filter(header => header !== 'col_rename' && header !== 'col_active')
                                      .map((header, index) => {
                                        const cleanHeader = header.replace(/^"|"$/g, ''); // Remove leading/trailing quotes
                                        const displayName = TableHeader.aliasNames?.[cleanHeader] || cleanHeader;

                                        return (
                                          <th key={index} style={{ fontSize: '12px', textAlign: 'center' }}>
                                            {displayName}
                                          </th>
                                        );
                                      })}

                                  </tr>
                                </thead>
                                <tbody>
                                  {currentRecords.map((row, rowIndex) => (
                                    <tr
                                      key={rowIndex}
                                      style={{
                                        lineHeight: '15px',
                                        backgroundColor: row.col_key.toLowerCase() === 'primary key' && row.col_name.toLowerCase() === 'reporting_date' ? '#f9f9f9' : 'transparent'
                                      }}
                                    >
                                      {isEditMode && (
                                        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={selectedRows.includes(rowIndex)}
                                            onChange={() => handleRowSelection(rowIndex)}
                                            style={{
                                              backgroundColor: selectedRows.includes(rowIndex) ? '#6c757d' : 'transparent',
                                              borderColor: '#6c757d',
                                              width: '16px',
                                              height: '16px',
                                              borderRadius: '50%',
                                              cursor: 'pointer',
                                            }}
                                          />
                                        </td>
                                      )}

                                      {headers
                                        .filter(header => header !== "col_rename" && header !== "col_active")
                                        .map((header, colIndex) => (
                                          <td
                                            key={colIndex}
                                            style={{
                                              fontSize: '12px',
                                              padding: '8px',
                                              textAlign: 'center',
                                              backgroundColor: colIndex % 2 === 0 ? '#ffffff' : '#f9f9f9',
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis'
                                            }}

                                            onClick={() => {
                                              if (header === "col_type" || header === "col_key") {
                                                setActiveEditCell({ rowIndex, columnName: header });
                                              }
                                            }}
                                          >
                                            {/* {isEditMode ? ( */}
                                            {isEditMode && selectedRows.includes(rowIndex) ? (
                                              header === "col_functions" ? (
                                                <div className="d-flex align-items-center">
                                                  <input
                                                    type="text"
                                                    value={
                                                      row[header] === null ||
                                                        row[header] === "null" ||
                                                        row[header] === "NULL"
                                                        ? ""
                                                        : row[header] || ""
                                                    }
                                                    onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                    onBlur={() => handleBlur(rowIndex, row["col_type"], header)}
                                                    className="form-control form-control-sm"
                                                    style={{
                                                      minWidth: "100px",
                                                      fontSize: "12px",
                                                    }}
                                                    disabled
                                                  />
                                                  <button
                                                    className="btn btn-sm btn-outline-secondary rounded-circle ms-2"
                                                    onClick={() => handleDropdownClick(rowIndex)}
                                                    style={{
                                                      padding: '2px',
                                                      width: '20px',
                                                      height: '20px',
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center'
                                                    }}
                                                  >
                                                    <FaPlus size={10} />
                                                  </button>
                                                </div>
                                              ) : header === "col_key" && activeEditCell.rowIndex === rowIndex && activeEditCell.columnName === header ? (
                                                <select
                                                  className="form-select form-select-sm"
                                                  value={row[header] || ""}
                                                  onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                  onBlur={() => {
                                                    handleBlur(rowIndex, row["col_type"], header);
                                                    setActiveEditCell({ rowIndex: null, columnName: null });
                                                  }}
                                                  style={{ fontSize: '12px' }}
                                                  autoFocus
                                                >
                                                  <option value="">Select Key</option>
                                                  {["PRIMARY KEY", "NOT NULL", "NULL"].map((keyType) => (
                                                    <option key={keyType} value={keyType}>{keyType}</option>
                                                  ))}
                                                </select>
                                              ) : header === "col_type" && activeEditCell.rowIndex === rowIndex && activeEditCell.columnName === header ? (
                                                <select
                                                  className="form-select form-select-sm"
                                                  value={row[header] || ""}
                                                  onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                  onBlur={() => {
                                                    handleBlur(rowIndex, row["col_type"], header);
                                                    setActiveEditCell({ rowIndex: null, columnName: null });
                                                  }}
                                                  style={{ fontSize: '12px' }}
                                                  autoFocus
                                                >
                                                  <option value="">Select Type</option>
                                                  {["INT", "VARCHAR", "DATE", "DOUBLE", "BOOLEAN", "DECIMAL", "FLOAT", "CHAR"].map((type) => (
                                                    <option key={type} value={type}>{type}</option>
                                                  ))}
                                                </select>
                                              ) : (
                                                <input
                                                  type="text"
                                                  value={
                                                    row[header] === null ||
                                                      row[header] === "null" ||
                                                      row[header] === "NULL"
                                                      ? ""
                                                      : row[header] || ""
                                                  }
                                                  onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                  onBlur={() => handleBlur(rowIndex, row["col_type"], header)}
                                                  className="form-control form-control-sm"
                                                  style={{
                                                    minWidth: "100px",
                                                    fontSize: "12px",
                                                  }}
                                                  disabled={
                                                    header === "col_length" &&
                                                    row["col_type"] &&
                                                    ["date", "long"].includes(row["col_type"].toLowerCase())
                                                  }
                                                />
                                              )
                                            ) : header === "col_label" ? (
                                              toCamelCaseforTableProps(row[header] || "")
                                            ) : ["col_key", "col_type", "col_name"].includes(header) ? (
                                              (row[header] || "").toLowerCase()
                                            ) : row[header] === null || row[header] === "null" || row[header] === "NULL" ? (
                                              ""
                                            ) : (
                                              row[header]
                                            )}
                                          </td>
                                        ))}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                          {/* </div> */}
                        </div>
                      </div>

                      {/* Controls Column */}
                      <div className="col-md-3">
                        <div className="mb-3">
                          {isTableNameVisible && (

                            <div>
                              <label htmlFor="tableName" className="form-label text-black mb-1">Table Name</label>
                              <input
                                type="text"
                                id="tableName"
                                value={editableTableName}

                                onChange={handleTableNameChange}
                                className={`form-control form-control-sm ${invalidTableNameMessage ? 'is-invalid' : ''}`}
                                placeholder="Enter table name"
                                disabled={isDownloaded}
                              />
                              {invalidTableNameMessage1 && (
                                <div
                                  className="invalid-feedback d-block"
                                  style={{ color: 'red', fontSize: '12px', marginLeft: '10px' }}
                                >
                                  {invalidTableNameMessage1}
                                </div>
                              )}


                            </div>
                          )}

                        </div>
                        <div className="mb-3">
                          <label htmlFor="department" className="form-label text-black mb-1">
                            Department
                          </label>
                          <select
                            className="form-select form-select-sm"
                            id="department"
                            value={selectedDept}  // You'll need a state for this
                            onChange={handleDepartmentChange}  // You'll need a handler for this
                            disabled={!editableTableName || invalidTableNameMessage}
                          >
                            <option value="">Select Department</option>
                            {Array.isArray(departments) &&
                              [...departments]
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((dept) => (
                                  <option key={dept.id} value={dept.name}>
                                    {dept.name}
                                  </option>
                                ))
                            }
                          </select>

                        </div>
                        <div className="mb-3">
                          <label htmlFor="checkerUser" className="form-label text-black mb-1">
                            Checker
                          </label>
                          <select
                            className="form-control form-control-sm"
                            id="dropdown"
                            value={selectedOption}
                            onChange={handleSelectChange}
                            disabled={!selectedDept}
                          >
                            <option value="">Select Checker</option>
                            {users.map((user) => (
                              <option key={user.id} value={user.id}>{user.name}</option>
                            ))}
                          </select>
                        </div>


                        <div className="d-flex justify-content-between gap-2">

                          {!isEditMode && !isValidationPassed && validErrorRecords.length === 0 && (
                            <div className="d-flex gap-2">
                              <button className="btn btn-sm btn-outline-secondary" onClick={handleEditClick}>Edit</button>
                              <button className="btn btn-sm btn-outline-primary" disabled={
                                !editableTableName ||
                                !!invalidTableNameMessage ||
                                !selectedDept ||
                                !selectedOption
                              } onClick={handleSubmit}>Submit</button>
                            </div>
                          )}

                          {isEditMode && !isValidationPassed && (
                            <div className="d-flex flex-wrap gap-3">
                              <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={handleAddRow}
                                title="Add Row"
                              >
                                <i className="bi bi-plus" style={{ fontSize: '24px' }}></i>
                              </button>

                              <div
                                className="d-inline-block"
                                title={selectedRows.length === 0 ? "Select checkbox and delete" : "Delete Row"}
                                data-bs-toggle="tooltip"
                              >
                                <button
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => setShowDeletePopup(true)}
                                  disabled={selectedRows.length === 0}
                                  style={{ pointerEvents: selectedRows.length === 0 ? 'none' : 'auto' }}
                                >
                                  <i className="bi bi-trash" style={{ fontSize: '24px' }}></i>
                                </button>
                              </div>

                              <button
                                className="btn btn-sm btn-outline-success"
                                onClick={handleUpdate}
                                title="Update"
                              >
                                <i className="bi bi-upload" style={{ fontSize: '24px' }}></i>
                              </button>
                              <button
                                className="btn btn-sm btn-outline-dark"
                                onClick={handleReset}
                                title="Reset"
                              >
                                <i className="bi bi-x-circle" style={{ fontSize: '24px' }}></i>
                              </button>
                            </div>
                          )}
                          {isValidationPassed && validErrorRecords.length === 0 && (

                            < div className="d-flex justify-content-center gap-2 mb-3">
                              <button
                                onClick={handlePreviewOption}
                                className="btn btn-sm btn-outline-primary"
                              >
                                Preview
                              </button>
                              <button
                                onClick={() => continueAfterValidation(validCSVData, validFormattedRecords)}
                                className="btn btn-success btn-sm"
                              >
                                Upload
                              </button>
                              <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={handleCancel}
                              >
                                Cancel
                              </button>
                            </div>
                          )}

                          {validErrorRecords.length > 0 && (
                            <div className="d-flex justify-content-center gap-2 mb-3">
                              <button
                                className="btn btn-primary btn-sm"
                                onClick={() => downloadErrorsAsPDF(validErrorRecords)}
                              >
                                Data Validation Report
                              </button>
                              <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={handleCancel}
                              >
                                Cancel
                              </button>
                            </div>
                          )}



                        </div>

                        <Modal show={showDeletePopup} onHide={() => setShowDeletePopup(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                          <Modal.Header
                            style={{
                              backgroundColor: '#366872',
                              color: 'white',
                              padding: '0.5rem 1rem'
                            }}
                          >
                            <Modal.Title style={{ fontSize: '16px' }}>Delete Confirmation</Modal.Title>
                          </Modal.Header>
                          <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                            <p>Are you sure you want to Delete the selected row?</p>
                          </Modal.Body>
                          <Modal.Footer style={{ borderTop: 'none' }}>
                            <Button variant="secondary" onClick={() => setShowDeletePopup(false)}>Cancel</Button>
                            <Button variant="primary" onClick={handleDeleteRow}>Delete</Button>
                          </Modal.Footer>
                        </Modal>


                        <Modal
                          show={isModalOpen}
                          onHide={() => setIsModalOpen(false)}
                          centered
                          style={{ marginTop: "0vh" }}
                        >

                          <Modal.Header
                            style={{
                              backgroundColor: '#366872',
                              color: 'white',
                              padding: '0.5rem 1rem'
                            }}
                          >
                            <Modal.Title style={{ fontSize: '16px' }}>
                              Select a function
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body style={{ fontSize: '14px' }}>
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control form-control sm"
                                placeholder="Type to search..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                              />
                              <ul
                                className="list-group mt-2"
                                style={{
                                  height: "150px",
                                  overflowY: "auto",
                                  border: "1px solid #ced4da", // Border for the list container
                                  borderRadius: "0.25rem",
                                  padding: "0", // Remove padding to avoid extra spacing
                                  margin: "0", // Remove margin to avoid extra space around the list
                                }}
                              >
                                <li
                                  className={`list-group-item ${selectedColName === "" ? "active" : ""}`}
                                  onClick={() => setSelectedColName("")}
                                  style={{
                                    cursor: "pointer",
                                    backgroundColor: selectedColName === "" ? "#e9ecef" : "transparent",
                                    color: selectedColName === "" ? "#495057" : "#212529",
                                    border: "none",
                                    padding: "2px 5px",

                                  }}
                                >
                                  Clear selection
                                </li>

                                {filteredColNames.length > 0 ? (
                                  filteredColNames.map((colName, index) => (
                                    <li
                                      key={index}
                                      className={`list-group-item ${colName === selectedColName ? "active" : ""}`}
                                      onClick={() => setSelectedColName(colName)}
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: selectedColName === colName ? "#e9ecef" : "transparent", // Highlight selected column
                                        color: selectedColName === colName ? "#495057" : "#212529", // Change text color for selected column
                                        border: "none", // Remove borders between list items
                                        padding: "2px 5px", // Minimal padding for list items
                                      }}
                                    >
                                      {colName}
                                    </li>
                                  ))
                                ) : (
                                  <li className="list-group-item text-muted" style={{ border: "none" }}>No matching columns</li>
                                )}
                              </ul>
                            </div>
                          </Modal.Body>
                          <Modal.Footer
                            style={{ borderTop: 'none' }}>
                            <Button variant="btn btn-sm btn-outline-secondary"

                              onClick={() => setIsModalOpen(false)}>
                              Close
                            </Button>
                            <Button

                              variant="btn btn-sm btn-outline-primary" onClick={handleOkClick}>
                              OK
                            </Button>
                          </Modal.Footer>
                        </Modal>

                        {(showPreview && previewData.length > 0) && (
                          <Modal
                            show={showModal}
                            onHide={handleCloseModal}
                            dialogClassName="modal-xl"
                            centered
                          >
                            <Modal.Header className="bg-light border-bottom px-0 py-2">
                              <div className="container-fluid px-0">
                                <div className="row align-items-center w-100 gx-0">
                                  {/* Left-aligned Table Name */}
                                  <div className="col-auto ps-3">
                                    <h6 className="mb-0">
                                      <strong>Table Name:</strong> <span>{toTitleCase(editableTableName)}</span>
                                    </h6>
                                  </div>

                                  {/* Center-aligned Validation Text */}
                                  <div className="col text-center">
                                    <span className="text-success fw-semibold">
                                      ✅ Validated Successfully
                                    </span>
                                  </div>

                                  {/* Right-aligned Close Button */}
                                  <div className="col-auto">
                                    <div className="d-flex justify-content-end pe-3">
                                      <button
                                        onClick={handleCloseModal}
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                      ></button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Modal.Header>

                            <Modal.Body style={{ overflowY: 'auto' }}>
                              {columnDetails && (
                                <div className={`${styles.checksumDetails}`}>
                                  <div className="text-dark">
                                    No. of Columns:
                                    <span>  {previewData.length > 0 ? previewData[0].split(',').length : 0}</span>
                                  </div>

                                  {(
                                    columnDetails.boolean_columns ||
                                    columnDetails.varchar_columns ||
                                    columnDetails.date_columns ||
                                    columnDetails.int_columns
                                  ) && <span style={{ marginLeft: '5px' }}>(</span>}

                                  {columnDetails.boolean_columns && (
                                    <span title={columnDetails.boolean_columns[0].col_name.join(", ")} style={{ cursor: 'pointer' }}>
                                      <div className='table-on-homepage-only'>
                                        Boolean: <strong className='total-number' style={{ cursor: 'pointer' }}>
                                          {columnDetails.boolean_columns[0].count}
                                        </strong>
                                      </div>
                                    </span>
                                  )}

                                  {columnDetails.varchar_columns && (
                                    <span title={columnDetails.varchar_columns[0].col_name.join(", ")} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                      <div className='table-on-homepage-only'>
                                        Character: <strong className='total-number' style={{ cursor: 'pointer' }}>
                                          {columnDetails.varchar_columns[0].count}
                                        </strong>
                                      </div>
                                    </span>
                                  )}
                                  {columnDetails.date_columns && (
                                    <span title={columnDetails.date_columns[0].col_name.join(", ")} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                      <div className='table-on-homepage-only'>
                                        Date: <strong className='total-number' style={{ cursor: 'pointer' }}>
                                          {columnDetails.date_columns[0].count}
                                        </strong>
                                      </div>
                                    </span>
                                  )}

                                  {(columnDetails.int_columns || columnDetails.decimal_columns || columnDetails.float_columns || columnDetails.double_columns) && (
                                    <span
                                      title={[
                                        ...(columnDetails.int_columns?.[0]?.col_name || []),
                                        ...(columnDetails.decimal_columns?.[0]?.col_name || []),
                                        ...(columnDetails.float_columns?.[0]?.col_name || []),
                                        ...(columnDetails.double_columns?.[0]?.col_name || [])
                                      ].join(", ")}
                                      style={{ cursor: "pointer", marginRight: "10px" }}
                                    >
                                      <div className='table-on-homepage-only'>
                                        Numeric:{" "}
                                        <strong className='total-number' style={{ cursor: "pointer" }}>
                                          {(columnDetails.int_columns?.[0]?.count || 0) +
                                            (columnDetails.decimal_columns?.[0]?.count || 0) +
                                            (columnDetails.float_columns?.[0]?.count || 0) +
                                            (columnDetails.double_columns?.[0]?.count || 0)}
                                        </strong>
                                      </div>
                                    </span>
                                  )}


                                  {(
                                    columnDetails.boolean_columns ||
                                    columnDetails.varchar_columns ||
                                    columnDetails.date_columns ||
                                    columnDetails.int_columns
                                  ) && <span style={{ marginLeft: '-8px' }}>)</span>}


                                  {(columnDetails.int_columns?.[0]?.col_name?.length ||
                                    columnDetails.decimal_columns?.[0]?.col_name?.length ||
                                    columnDetails.number_columns?.[0]?.col_name?.length ||
                                    columnDetails.double_columns?.[0]?.col_name?.length ||
                                    columnDetails.float_columns?.[0]?.col_name?.length) > 0 && (

                                      <Dropdown style={{ marginLeft: 'auto' }}>
                                        <div className='table-on-homepage-only'>
                                          <Dropdown.Toggle variant="light" className='dropdown-button-color btn-sm'>
                                            Calculate Sum / Total
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                            {[
                                              // ...(columnDetails.int_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || []),
                                              ...(columnDetails.int_columns?.[0]?.col_name?.map(col => col.replace(/\s+/g, "").toLowerCase()) || []),
                                              ...(columnDetails.decimal_columns?.[0]?.col_name?.map(col => col.replace(/\s+/g, "").toLowerCase()) || []),
                                              ...(columnDetails.number_columns?.[0]?.col_name?.map(col => col.replace(/\s+/g, "").toLowerCase()) || []),
                                              ...(columnDetails.double_columns?.[0]?.col_name?.map(col => col.replace(/\s+/g, "").toLowerCase()) || []),
                                              ...(columnDetails.float_columns?.[0]?.col_name?.map(col => col.replace(/\s+/g, "").toLowerCase()) || [])

                                            ].map((col, index) => {
                                              const isSelected = selectedNumericColumns.includes(col);
                                              return (
                                                <Dropdown.Item
                                                  key={index}
                                                  as="div"
                                                  onClick={() => handleCheckboxChange(col)} // Clicking the row selects/unselects
                                                  style={{
                                                    color: isSelected ? "orange" : "black", // Change text color for better visibility
                                                  }}
                                                >
                                                  <Form.Check
                                                    type="checkbox"
                                                    label={<span className='columns-dropdown'>{col}</span>}
                                                    checked={isSelected}
                                                    onClick={(e) => e.stopPropagation()} // Prevents row click when clicking checkbox
                                                    onChange={() => handleCheckboxChange(col)} // Ensure total updates when checkbox is clicked
                                                    style={{
                                                      accentColor: isSelected ? "white" : "#E67016", // Checkbox color change
                                                    }}
                                                  />
                                                </Dropdown.Item>
                                              );
                                            })}
                                          </Dropdown.Menu>
                                        </div>
                                      </Dropdown>

                                    )}
                                </div>
                              )}
                              {/* Total Records Count */}
                              {previewData.length > 1 && (
                                <div className={`${styles.checksumDetails}`}>
                                  <div className="text-dark">
                                    No. of Records: <span>{previewData.length - 1}</span>
                                  </div>
                                </div>
                              )}

                              {/* Table Preview */}
                              {previewData.length > 0 ? (
                                <div className='table-on-homepage-only'>
                                  <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                    <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                      <thead className="thead-light">
                                        <tr>
                                          {previewData[0].split(',').map((header, index) => {
                                            const cleanHeader = header.trim().replace(/^"|"$/g, ''); // Remove leading/trailing quotes
                                            return (
                                              <th key={index} style={{ padding: '8px', backgroundColor: '#f8f9fa' }}>
                                                {cleanHeader}
                                              </th>
                                            );
                                          })}
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {previewData.slice(1, previewLimit + 1).map((row, rowIndex) => {
                                          const regex = /(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g;
                                          // const matches = [...row.matchAll(regex)].map(match => match[1] ?? match[2] ?? '');
                                          const matches = [...row.matchAll(regex)].map(match => (match[1] !== undefined ? match[1] : match[2] ?? ''));
                                          return (
                                            <tr key={rowIndex}>
                                              {matches.map((cell, cellIndex) => {
                                                let cleanedCell = cell.trim();
                                                // const columnName = previewData[0].split(',')[cellIndex]?.trim();
                                                const columnName = previewData[0].split(',')[cellIndex]?.trim().toLowerCase();
                                                let style = { whiteSpace: 'nowrap', textAlign: 'left' }; // Default left alignment

                                                // Remove parentheses and replace with minus sign
                                                cleanedCell = cleanedCell.replace(/\(([^)]+)\)/, "-$1");
                                                if (
                                                  int_columns.map(col => col.toLowerCase()).includes(columnName) ||
                                                  decimal_columns.map(col => col.toLowerCase()).includes(columnName) ||
                                                  number_columns.map(col => col.toLowerCase()).includes(columnName) ||
                                                  float_columns.map(col => col.toLowerCase()).includes(columnName) ||
                                                  double_columns.map(col => col.toLowerCase()).includes(columnName)
                                                ) {
                                                  style.textAlign = 'right'; // Right-align numeric columns

                                                }

                                                return <td key={cellIndex} style={style}>{cleanedCell}</td>;
                                              })}
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                      {/* Footer for totals */}
                                      {selectedNumericColumns.length > 0 && (
                                        <tfoot
                                          className='table-footer-details'
                                          style={
                                            {
                                              position: "sticky",
                                              bottom: "0",
                                              zIndex: "1",
                                            }
                                          }
                                        >
                                          <tr>
                                            {previewData[0].split(",").map((header, headerIndex) => {
                                              const normalizeColumnName = (name) => name.replace(/\s+/g, "").toLowerCase(); // Remove spaces & lowercase
                                              const trimmedHeader = normalizeColumnName(header); // Normalize header

                                              const isSelected = selectedNumericColumns
                                                .map(col => normalizeColumnName(col)) // Normalize selected columns
                                                .includes(trimmedHeader);

                                              let totalValue = columnSums[trimmedHeader];

                                              if (isSelected) {
                                                let numericValue = parseFloat(
                                                  (totalValue || "0")
                                                    .toString()
                                                    .replace(/\(([^)]+)\)/, "-$1") // Convert (value) to -value
                                                    .replace(/,/g, "") // Remove commas before parsing
                                                );

                                                totalValue = numericValue.toLocaleString("en-US", {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                });
                                              }
                                              return (
                                                <td
                                                  key={headerIndex}
                                                  className='table-footer-color'

                                                >
                                                  {isSelected ? `${totalValue}` : ""}
                                                </td>
                                              );
                                            })}
                                          </tr>
                                        </tfoot>

                                      )}
                                    </table>
                                  </div>
                                </div>

                              ) : (
                                <div className='table-on-homepage-only'>
                                  <p className="text-center" style={{ color: '#555', ...ListPopSize }}>No preview data available.</p>
                                </div>
                              )
                              }
                              {

                                previewLimit + 1 < previewData.length && (
                                  <div className='table-on-homepage-only'>
                                    <div className="text-center mt-3">
                                      <Button onClick={() => setPreviewLimit(previewLimit + 100)} variant="primary" style={{ fontWeight: 'bold' }}>
                                        Load More
                                      </Button>
                                    </div>
                                  </div>
                                )

                              }
                            </Modal.Body >
                            <Modal.Footer>
                              <Button onClick={() => continueAfterValidation(validCSVData, validFormattedRecords)}
                                className="btn btn-success btn-sm"
                              >
                                Upload</Button>
                            </Modal.Footer>
                          </Modal >
                        )}
                        {showAllowUploadPopup && (
                          <Modal show onHide={handleCancelUpload} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                            <Modal.Header style={{ backgroundColor: '#366872', color: 'white', padding: '0.5rem 1rem' }}>
                              <Modal.Title style={{ fontSize: '16px' }}>Confirmation</Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}
                              /* <sttong>{toTitleCase(editableTableName)}</sttong> Template is already exists. Do you wish to upload data with the same template? */
                              dangerouslySetInnerHTML={{
                                __html: modalMessage3.replace(/\n/g, '<br />')
                              }}>
                            </Modal.Body>
                            <Modal.Footer style={{ borderTop: 'none' }}>
                              <Button variant="secondary" onClick={handleCancelUpload}>No</Button>
                              <Button variant="primary" onClick={handleForceUpload}>Yes</Button>
                            </Modal.Footer>
                          </Modal>
                        )}

                        <Modal show={modalMessage} backdrop="static"  // <-- This prevents closing on outside click
                          keyboard={false} style={{ marginTop: '12vh' }}>
                          <div
                            className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                            role="alert"
                            style={{ marginBottom: '0' }}
                          >
                            <div className="d-flex align-items-center">
                              {messageType === 'success' ? (
                                <span className="me-2" style={{ color: 'green', marginBottom: '0px' }}>✅</span>
                              ) : messageType === 'warning' ? (
                                <span className="me-2" style={{ color: 'orange', marginBottom: '0px' }}>⚠️</span>
                              ) : (
                                <span className="me-2" style={{ color: 'red', marginBottom: '0px' }}>❌</span>
                              )}
                              <p
                                style={{
                                  display: 'inline',
                                  marginBottom: '0px',
                                  fontSize: '14px',
                                  color:
                                    messageType === 'success'
                                      ? 'green'
                                      : messageType === 'warning'
                                        ? 'orange'
                                        : 'red' // Change text color based on messageType
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: modalMessage.replace(/\n/g, '<br />')
                                }}>


                              </p>
                            </div>

                            <button
                              type="button"
                              className="btn-close"
                              // onClick={handleModalClose}
                              onClick={() => {
                                if (messageType === 'success') {
                                  handleCancel();        // Clear everything
                                } else {
                                  handleModalClose();   // Just close modal
                                }
                              }}
                              style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }} // Adjust width, height, and position
                            ></button>
                          </div>
                        </Modal>

                        <Modal show={showModal1} backdrop="static"  // <-- This prevents closing on outside click
                          keyboard={false} style={{ marginTop: '30vh' }}>
                          <div
                            className={`alert alert-${messageType1 === 'success' ? 'success' : messageType1 === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                            role="alert"
                            style={{ marginBottom: '0' }}
                          >
                            <div className="d-flex align-items-center">
                              {messageType1 === 'success' ? (
                                <span className="me-2" style={{ color: 'green', marginBottom: '0px' }}>✅</span>
                              ) : messageType1 === 'error' ? (
                                <span className="me-2" style={{ color: 'red', marginBottom: '0px' }}>⚠️</span>
                              ) : (
                                <span className="me-2" style={{ color: 'red', marginBottom: '0px' }}>❌</span>
                              )}
                              <p
                                style={{
                                  display: 'inline',
                                  marginBottom: '0px',
                                  fontSize: '14px',
                                  color:
                                    messageType1 === 'success'
                                      ? 'green'
                                      : messageType1 === 'error'
                                        ? 'orange'
                                        : 'red' // Change text color based on messageType
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: modalMessage1.replace(/\n/g, '<br />')
                                }}>

                              </p>
                            </div>

                            <button
                              type="button"
                              className="btn-close"
                              onClick={handleSuccessModalClose}
                              style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }} // Adjust width, height, and position
                            ></button>
                          </div>
                        </Modal>
                        <Modal show={showModal2} backdrop="static"  // <-- This prevents closing on outside click
                          keyboard={false} style={{ marginTop: '15vh' }}>
                          <div
                            className={`alert alert-${messageType2 === 'success' ? 'success' : messageType2 === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                            role="alert"
                            style={{ marginBottom: '0' }}
                          >
                            <div className="d-flex align-items-center">
                              {messageType2 === 'success' ? (
                                <span className="me-2" style={{ color: 'green', marginBottom: '0px' }}>✅</span>
                              ) : messageType2 === 'warning' ? (
                                <span className="me-2" style={{ color: 'orange', marginBottom: '0px' }}>⚠️</span>
                              ) : (
                                <span className="me-2" style={{ color: 'red', marginBottom: '0px' }}>❌</span>
                              )}
                              <p
                                style={{
                                  display: 'inline',
                                  marginBottom: '0px',
                                  fontSize: '14px',
                                  color:
                                    messageType2 === 'success'
                                      ? 'green'
                                      : messageType2 === 'warning'
                                        ? 'orange'
                                        : 'red' // Change text color based on messageType
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: modalMessage2.replace(/\n/g, '<br />')
                                }}>

                              </p>
                            </div>

                            <button
                              type="button"
                              className="btn-close"
                              onClick={handleErrorModalClose}
                              style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }} // Adjust width, height, and position
                            ></button>
                          </div>

                        </Modal>

                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main >
      <Footer />
    </div >
  );
};

export default TemplateUpload;
